const PROTOCOL = 'https:'
const env = window.ODMINFO?.env || {
  'downtown8.net': 'test',
  'eshinebts.us': 'bts',
  'trytabletop.com': 'pro',
  'downtown8.cn': 'test',
  'dangtang8.net': 'bts',
  'eshine.cn': 'pro',
}[WWWDOMAIN] || 'test'
const envBo = window.ODMINFO?.bo || {
  'downtown8.net': 'us',
  'eshinebts.us': 'us',
  'trytabletop.com': 'us',
  'downtown8.cn': 'cn',
  'dangtang8.net': 'cn',
  'eshine.cn': 'cn',
}[WWWDOMAIN] || 'us'
const SERVERDOMAIN = window.ODMINFO?.serverDomain || {
  testus: 'downtown8.net',
  btsus: 'eshinebts.us',
  prous: 'eshine.us',
  testcn: 'downtown8.net',
  btscn: 'dangtang8.net',
  procn: 'eshine.cn'
}[env + envBo]
let facebookAppId = window.ODMINFO?.thirdAppIds?.facebook || {
  local: '881425386024413', // posbee local 1137729306958458
  testus: '730308531209017',
  btsus: '327705501936157',
  prous: '330751434905174',
  testcn: '',
  btscn: '',
  procn: ''
}[process.env.NODE_ENV === 'development' ? 'local' : env + envBo] || 'testus'
let googleAppId = window.ODMINFO?.thirdAppIds?.google || '976087053892-fige93uf6uogiv6jcpu1sq7d4feqsjuo.apps.googleusercontent.com'
const gateWayUrl = `${PROTOCOL}//gateway.${SERVERDOMAIN}`

// 老的wp
// const WECHAT_WPT = {
//   testus: 'wp.dangtang8.net',
//   btsus: '',
//   prous: '',
//   testcn: 'wp.dangtang8.net',
//   btscn: 'wp.dangtang8.net',
//   procn: 'wp.eshine.cn'
// }[env + envBo]

const ARMS: { pid: string; imgUrl: string } = ({
  cn: {
    pid: 'tvt3y@a40311db2c9a6d4',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?'
  },
  us: {
    pid: 'tvt3y@1a623dc68e4edea',
    imgUrl: 'https://retcode-us-west-1.arms.aliyuncs.com/r.png?'
  }
} as any)[envBo]

const OSSI18NMap = {
  'us': {
    'test': `${PROTOCOL}//eshine-image-test.oss-cn-hangzhou.aliyuncs.com`,
    'bts': `${PROTOCOL}//eshine-image-handler.s3.us-west-2.amazonaws.com/eshine-image-handler`,
    'pro': `${PROTOCOL}//eshine-image-handler.s3.us-west-2.amazonaws.com/eshine-image-handler`
  },
  'cn': {
    'test': `${PROTOCOL}//eshine-image-test.oss-cn-hangzhou.aliyuncs.com`,
    'bts': `${PROTOCOL}//eshinebts-image.oss-cn-hangzhou.aliyuncs.com`,
    'pro': `${PROTOCOL}//eshine-image.oss-cn-hangzhou.aliyuncs.com`
  }
}

let openInvoiceUrl = `https://handtop.${SERVERDOMAIN}/invoice/#/`
if (env === 'pro') {
  openInvoiceUrl = `https://go.${SERVERDOMAIN}/invoice/#/`
}

const ENV = {
  envBo: envBo as TBo,
  env: env as TEnvironment,
  SERVERDOMAIN,
  WEBSITE: `${PROTOCOL}//${location.host}`,
  POSMOBILE: `${gateWayUrl}/posMobile`,
  INVOICE: `${gateWayUrl}/invoiceapi`,
  ORDER: `${gateWayUrl}/jordersmobile`,
  ORDERJMOBILE: `${gateWayUrl}/jordersmobile`,
  ORDERMEMBER: `${gateWayUrl}/jordersmember`,
  ORDERSERVICE: `${gateWayUrl}/j-orders-service`,
  RECOMMEND: `${gateWayUrl}/recommend/jl`,
  PAYING: `${gateWayUrl}/mobile-j-pay-service`,
  JMOBILE: `${gateWayUrl}/jposmobile`,
  JPOSSERVICE: `${gateWayUrl}/j-pos-service`,
  JFEE: `${gateWayUrl}/j-fee-service`,
  MEMBER: `${gateWayUrl}/mobile-memberservice`,
  KITCHEN: `${gateWayUrl}/kdsforpos`,
  REPORT: `${gateWayUrl}/onedata`,
  POSMANAGER: `${gateWayUrl}/posmanager`,
  DISABLE_MKT: false,
  GLOBAL_ID: `${PROTOCOL}//gwp.${SERVERDOMAIN}/globalid`,
  openInvoiceUrl: openInvoiceUrl,
  facebookAppId,
  googleAppId,
  REDISDB: `${PROTOCOL}//redisdb.${SERVERDOMAIN}/`,
  GWPT: `${PROTOCOL}//gwp.${SERVERDOMAIN}`,
  GWP: `gwp.${SERVERDOMAIN}`,
  GWPWPROXY: `${PROTOCOL}//gwp.${SERVERDOMAIN}/wproxy`,
  AUTH: `${gateWayUrl}/j-auth-service`,
  OSSI18N: OSSI18NMap[envBo][env],
  LOGPROXY: `${PROTOCOL}//logproxy.${SERVERDOMAIN}`,
  ARMS: ARMS,
  VOICE: `${gateWayUrl}/onevoice/translate`,
  POSCONFIG: `${gateWayUrl}/posConfig`,
  CONFIGAPIINTERIOR: `${gateWayUrl}/iconfig-interior`,
  SIGNJALLIANCESERVICE: `${PROTOCOL}//gateway.${SERVERDOMAIN}/sign-j-alliance-service/grant`,
  ONENET: `${PROTOCOL}//onenet.${SERVERDOMAIN}`,
  gateWayUrl,
  JESHINECOIN: `${gateWayUrl}/j-eshine-coin-account`,
  JMESSAGE: `${gateWayUrl}/j-message-service`,
  ACTIVITY_RESERVATION: `${gateWayUrl}/g-activity`,
}
window.ENV = ENV
export default ENV

/**
 * 公共资源路径
 */
export const commonResourceMap = {
  test: `${PROTOCOL}//handtop.${WWWDOMAIN}`,
  bts: `${PROTOCOL}//handtop.${WWWDOMAIN}`,
  pro: `${PROTOCOL}//${location.host}`
}

/**
 * 获取公共资源路径
 */
export const getCommonResourcesPath = function (type?: 'image' | 'auth') {
  const pathMap = {
    image: 'resources/images',
    auth: 'auth/wechatauth.html'
  }
  return `${commonResourceMap[env]}/${type ? pathMap[type] : ''}`
}
